import { render, staticRenderFns } from "./DetailProduit.vue?vue&type=template&id=f8724aac&"
import script from "./DetailProduit.vue?vue&type=script&lang=js&"
export * from "./DetailProduit.vue?vue&type=script&lang=js&"
import style0 from "./DetailProduit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports